import React, { useEffect } from 'react';
import styled from 'styled-components';
import Box from '../layout/box';

const Content = styled.main`
  padding-top: 16px;
  border-top: 1px solid #e8e4d0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Title = styled.h1`
  font-weight: 700;
  font-size: 28px;
  color: #1a1a2e;
  margin: 0;
`;

const Description = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: #6c757d;
  margin: 0;
  font-style: italic;
`;

const Header = styled.header`
  height: 60px;
  align-items: flex-start;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 16px 0;

  @media (max-width: 765px) {
    flex-direction: column;
    height: auto;
    gap: 16px;
  }
`;

const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Icon = styled.img`
  height: 28px;
  width: auto;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
`;

const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  line-height: 1;
  color: #1a1a2e;
`;

const scrollToTop = () => {
  window.scrollTo(0, 0);
};

const Page = ({ children, title, description, sideAction, icon }) => {
  useEffect(() => {
    scrollToTop();
  }, []);

  const renderIcon = () => {
    if (!icon) return null;
    if (typeof icon === 'string') {
      return <Icon src={icon} alt='' />;
    }
    return <IconWrapper>{icon}</IconWrapper>;
  };

  return (
    <Box>
      <Header>
        <Div>
          {renderIcon()}
          <TitleContainer>
            <Title>{title}</Title>
            {description && <Description>{description}</Description>}
          </TitleContainer>
        </Div>
        <Div>{sideAction && sideAction}</Div>
      </Header>
      <Content>{children}</Content>
    </Box>
  );
};

export default Page;
